import React, { useRef, useState } from "react";
import styled from "styled-components";
import { gql, useLazyQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";

import LoginLayout from "../LoginLayout";
import { TextBtn } from "../../components/inputs/TextBtn";
import { Title } from "../../components/inputs/Title";
import { Desc } from "../../components/inputs/Desc";
import LoginImage from "../../assets/login_images/screen.png";
import { TextInputWTitle } from "../../components/inputs/TextInputWTitle";
import ReCAPTCHA from 'react-google-recaptcha';
const StyleCss = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  .recaptca {
    width: 100%;
  }
`;

const Login_Query = gql`
    query LoginQuery($Token: String!, $Code: String!){
        verifyLogin(Token: $Token, Code: $Code){
            status
            Email
            Mobile
            data
        }
    }
`;

function LoginVerify(props) {
  const history = useHistory();

  const [code, setCode] = useState("");
  const [errorText, setError] = useState("");
  const captcha = useRef();

  const [LoginQuery, loginState] = useLazyQuery(Login_Query, {
    onCompleted: proccessData,
    fetchPolicy: "network-only",
  });

  function proccessData(event) {
    if(event.verifyLogin.status){
      localStorage.setItem('token-pod',event.verifyLogin.data)
      localStorage.setItem('Email',event.verifyLogin.Email);
      props.updateLogin()
      history.push("/dash");
    } else {
        // error
        setError(event.verifyLogin.data)
    }
  }

  function sendData() {
    // console.log('here')
    if (code.length) {
      LoginQuery({
        variables: {
            Token: props.location.state.token,
            Code: code,
        }
      });
    }
  }
  
  
  onchange = (e) => {
    let value = e.target.value;
    switch (e.target.name) {
        case 'Code':
            setCode(value)
            break;
        default: 
            break;
    }
  }

  return (
    <LoginLayout image={LoginImage}>
      <StyleCss className="data">
        <Title className={"styletext"}>Login</Title>
        <Desc className={"styletext"}>
          Enter code for Login
        </Desc>
        <div className="spacer-m" />
        <TextInputWTitle
          onEnter={sendData}
          name={"Code"}
          value={code}
          onchange={onchange}
          error={''}
          title="Code"
        />
        <div className="spacer-s" />
        <TextBtn
          type={"button"}
          text={"Login"}
          onclick={sendData}
          loading={loginState.loading}
          disabled={!code.length || loginState.loading}
        />
        <div className="spacer-l" />
        <div className="spacer-l" />
      </StyleCss>
    </LoginLayout>
  );
}

export default LoginVerify;
